'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = handleize;
function handleize(s) {
  return s.replace(/\W+/g, '-').toLowerCase();
}